export const salesRepsTranslations = {
  ar: {
    title: 'المناديب',
    addNew: 'إضافة مندوب جديد',
    nameEN: 'الاسم (إنجليزي)',
    code: 'الكود',
    mobile: 'الجوال',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    address: 'العنوان',
    defaultCommissionRate: 'نسبة العمولة الافتراضية',
    noSalesReps: 'لا يوجد مندوبي مبيعات',
    active: 'نشط',
    inactive: 'غير نشط',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    search: 'بحث',
    allBranches: 'جميع الفروع',
    updateSalesRep: 'تحديث مندوب',
    createSalesRep: 'إنشاء مندوب جديد',
    deleteSalesRep: 'حذف مندوب',
    confirmDelete: 'تأكيد الحذف',
    selectSalesRep: 'اختر المندوب',
  },
  en: {
    title: 'Sales Representatives',
    addNew: 'Add New Sales Rep',
    nameEN: 'Name (English)',
    code: 'Code',
    mobile: 'Mobile',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    defaultCommissionRate: 'Default Commission Rate',
    noSalesReps: 'No sales representatives',
    active: 'Active',
    inactive: 'Inactive',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    search: 'Search',
    allBranches: 'All Branches',
    updateSalesRep: 'Update sales rep',
    createSalesRep: 'Create new sales rep',
    deleteSalesRep: 'Delete sales rep',
    confirmDelete: 'Confirm Delete',
    selectSalesRep: 'Select Sales Rep',
  },
  fr: {
    title: 'Représentants commerciaux',
    addNew: 'Ajouter un nouveau représentant',
    nameEN: 'Nom (Anglais)',
    code: 'Code',
    mobile: 'Mobile',
    phone: 'Téléphone',
    email: 'E-mail',
    address: 'Adresse',
    defaultCommissionRate: 'Taux de commission par défaut',
    noSalesReps: 'Aucun représentant commercial',
    active: 'Actif',
    inactive: 'Inactif',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    search: 'Rechercher',
    allBranches: 'Toutes les succursales',
    updateSalesRep: 'Mettre à jour le représentant',
    createSalesRep: 'Créer un nouveau représentant',
    deleteSalesRep: 'Supprimer le représentant',
    confirmDelete: 'Confirmer la suppression',
  },
}

